import { FullProject, PackageWithProjects, ProjectInvoice, QuotationRequest } from 'entities';

import { projectInvoiceConfigByCode } from '../projectInvoice';

import { calculateProjectTotal } from '../../../projects/utils';

import { getExactDecimal } from 'utils/number';

function getPercentageTakers({
  quotationRequests,
  projectInvoices,
}: Pick<FullProject['invoice'], 'projectInvoices' | 'quotationRequests' | 'package'>): (
  | QuotationRequest
  | ProjectInvoice
)[] {
  return [
    ...quotationRequests.filter(({ answered }) => !answered),
    ...projectInvoices.filter(
      ({ status }) => projectInvoiceConfigByCode[status].valueCountsAsTaken,
    ),
  ];
}

function calculatePackageTaken({ projects }: PackageWithProjects, projectId: string): number {
  const attached = projects.find(({ project }) => project === projectId);

  return Number(attached?.valueInProjectCurrency ?? attached?.value);
}

export function getProjectAmountTaken({
  package: attachedPackage,
  project,
  ...params
}: Pick<FullProject['invoice'], 'projectInvoices' | 'quotationRequests' | 'package'> & {
  project: string | { id: string };
}): number {
  if (attachedPackage)
    return calculatePackageTaken(
      attachedPackage,
      typeof project === 'object' ? project.id : project,
    );

  const percentageTakers = getPercentageTakers(params);

  const takenAmount = percentageTakers.reduce(
    (acc, next) => acc + Number(next.valueInProjectCurrency),
    0,
  );

  return takenAmount;
}

export function getProjectAvailableAmount({ invoice, services }: FullProject): number {
  const projectCost = calculateProjectTotal(services);

  const takenAmount = getProjectAmountTaken(invoice);

  const available = Number(projectCost) - takenAmount;

  return getExactDecimal(available);
}

export function doesProjectHasAvailableAmount(project: FullProject): boolean {
  const available = getProjectAvailableAmount(project);

  return available > 0;
}
